/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do they account for muscle?`)
};

const es_iw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Tienen en cuenta el músculo?`)
};

const de_iw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berücksichtigen sie Muskelmasse?`)
};

const nl_iw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Houden ze rekening met spiermassa?`)
};

const fr_iw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiennent-elles compte du muscle ?`)
};

const it_iw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tengono conto della massa muscolare?`)
};

const pt_br2_iw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elas levam em conta a massa muscular?`)
};

const pt_iw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Têm em conta o músculo?`)
};

const ja_iw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`筋肉量は考慮されますか?`)
};

const zh_iw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这些公式考虑肌肉量吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iw_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iw_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iw_faq_q3", locale)
	if (locale === "en") return en_iw_faq_q3(inputs)
	if (locale === "es") return es_iw_faq_q3(inputs)
	if (locale === "de") return de_iw_faq_q3(inputs)
	if (locale === "nl") return nl_iw_faq_q3(inputs)
	if (locale === "fr") return fr_iw_faq_q3(inputs)
	if (locale === "it") return it_iw_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_iw_faq_q3(inputs)
	if (locale === "pt") return pt_iw_faq_q3(inputs)
	if (locale === "ja") return ja_iw_faq_q3(inputs)
	return zh_iw_faq_q3(inputs)
};